import { gql } from '@apollo/client';
import { QnA } from 'types';

export const GET_PROMOTION_BY_USER = gql`
  query GetPromotionByUser($userId: ID!) {
    getPromotionByUser(userId: $userId) {
      answer {
        _id
        desc
      }
      question {
        _id
        desc
      }
    }
  }
`;

export type GetPromotionByUserResponse = {
  getPromotionByUser: {
    answer: QnA;
    question: QnA;
  }[];
};

export type getPromotionByUserVariables = {
  userId: string;
  year?: number;
};
